"use strict";
module.exports = function(value, done) {
  return { value, done };
};
